/**
 * modify-comment-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Comment, Visibility } from "../../../intake-form/comment";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class ModifyCommentRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_MODIFY_COMMENT;
	public static tag : MessageTag = MessageTag.REQ_MODIFY_COMMENT;

  public isPublic : boolean;
  public groupIds : number[];

  /**
   * Construct a new {@link ModifyCommentRequest}.
   */
  constructor (
    public commentId : number,
    public comment : string,
    visibility : Visibility,
    selfGroupIds : number[]
  )
  {
    super();
    Comment.applyVisibilityToMessage(this, visibility, selfGroupIds);
  }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/collaboration/modify-comment-request.ts